import React from 'react';
import { Typography } from '@tvg/fuse/typography';
import VisiblyHidden from '../VisiblyHidden';
import { DescriptionProps } from './DescriptionProps';
import styles from './Description.module.css';

function Description({ description, ean = '', itemNumber, useAccordion = false }: DescriptionProps) {
  return (
    <div
      className={[styles.container, useAccordion ? '' : styles.containerStandalone].filter(Boolean).join(' ')}
      data-testid="description_wrapper_container"
      // eslint-disable-next-line react/no-unknown-property
      about={useAccordion ? 'true' : 'false'}
    >
      <div className={styles.textContainer} data-testid="product_description_container">
        {!useAccordion && (
          <Typography className={styles.title} tag="h2" size="3" data-testid="product_description_header">
            Product description
          </Typography>
        )}

        <p
          className={styles.text}
          dangerouslySetInnerHTML={{
            __html: `<strong>Item number:</strong> ${itemNumber}`,
          }}
          data-testid="product_description_itemNumber"
        />

        {ean && (
          <>
            <p
              className={styles.text}
              dangerouslySetInnerHTML={{
                __html: `<strong>EAN:</strong> ${ean}`,
              }}
              aria-hidden
              data-testid="product_description_ean"
            />
            <VisiblyHidden
              text={`E.A.N: ${ean.split('').join(' ')}`}
              testId="product_description_ean_accessibilityText"
            />
          </>
        )}

        <div
          className={styles.body}
          dangerouslySetInnerHTML={{
            __html: description,
          }}
          data-testid="product_description_body"
        />
      </div>
    </div>
  );
}

export default Description;
